var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paper-example"},[_c('h1',[_vm._v("2019届高三历史人教版一轮复习考点集训：考点41   物质生活和习俗的变迁")]),_vm._v(" "),_c('div',{staticClass:"paper-body"},_vm._l((_vm.questions),function(question,index){return _c('question-box',{key:index,attrs:{"question":question}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7762d318","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/front/introduce/history-paper/paper-example-2/index.vue
// module id = null
// module chunks = 